(() => {
  function init(root) {
    if(root.dataset.tocReady)return;
    root.dataset.tocReady='true';
    const toc=root.querySelector('[data-article-toc]');
    if(!toc)return;
    const headings=[...root.querySelectorAll('[data-article-content] h2')].filter(h=>h.textContent.trim());
    const list=toc.querySelector('ol');
    if(!headings.length)return;
    list.replaceChildren();
    const links=headings.map((heading,index)=>{
      if(!heading.id){let id=`${root.id}-heading-${index+1}`;while(document.getElementById(id))id+='-section';heading.id=id;}
      const item=document.createElement('li'), link=document.createElement('a');
      link.href=`#${encodeURIComponent(heading.id)}`;link.textContent=heading.textContent;
      item.append(link);list.append(item);return link;
    });
    if(matchMedia('(max-width:749px)').matches)toc.querySelector('details').open=false;
    const observer=new IntersectionObserver(entries=>{
      const visible=entries.filter(entry=>entry.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top)[0];
      if(!visible)return;
      links.forEach((link,index)=>{if(headings[index]===visible.target)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
    },{rootMargin:'-100px 0px -55% 0px'});
    headings.forEach(heading=>observer.observe(heading));
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
  }
  document.querySelectorAll('[data-article-detail]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-article-detail]').forEach(init));
})();
